import {Component, Input} from '@angular/core';
import {Service} from '../../../entities/photographer/service.entity';
import {CurrencyPipe} from '@angular/common';
import {TranslocoPipe} from '@jsverse/transloco';
import {AppImageComponent} from '../../../../core/components/image/image';
import {FormatDurationPipe} from '../../../../core/pipes/format-duration.pipe';

@Component({
  selector: 'app-photographer-service',
  imports: [
    CurrencyPipe,
    TranslocoPipe,
    AppImageComponent,
    FormatDurationPipe,
  ],
  templateUrl: './photographer-service.html',
  styleUrls: ['./photographer-service.scss']
})
export class PhotographerService {
  @Input() service: Service|null = null;
  @Input() imageSize: number = 156;

  public get coverImage(): string|null {
    const service: any = this.service;
    const mainImage = service?.image ?? null;
    if (mainImage) return mainImage;

    const photos = service?.photos;
    if (Array.isArray(photos)) {
      const firstPhotoWithUrl = photos.find((photo: any) => !!photo?.url);
      return firstPhotoWithUrl?.url ?? null;
    }

    return null;
  }

  public hasDiscount(): boolean {
    const discountActive = (this.service as any)?.discountActive ?? (this.service as any)?.discount_active;
    const discount = this.getDiscountValue();

    return !!discountActive && discount > 0;
  }

  public getDiscountValue(): number {
    return (this.service as any)?.discount ?? (this.service as any)?.discount ?? 0;
  }

  public hasPriceRange(): boolean {
    return !!((this.service as any)?.priceRangeActive ?? (this.service as any)?.price_range_active);
  }

  public getMinPublicPrice(): number|null {
    return (this.service as any)?.priceRangeMinPublic ?? (this.service as any)?.price_range_min_public ?? null;
  }

  public getPublicPrice(): number|null {
    return (this.service as any)?.publicPrice ?? null;
  }

  public getDiscountedPrice(amount: number|null): number|null {
    if (amount === null) {
      return null;
    }

    const discount = this.getDiscountValue();
    return amount * (1 - discount / 100);
  }
}
